import { useState } from "react";
import { Save } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import Stepper from "@/components/Stepper";
import { useLab } from "@/context/LabContext";
import IssueInputStep from "@/steps/IssueInputStep";
import PositionMappingStep from "@/steps/PositionMappingStep";
import NeedsStep from "@/steps/NeedsStep";
import SolutionsStep from "@/steps/SolutionsStep";

export default function Lab() {
  const { map, setMap, step } = useLab();
  const [saving, setSaving] = useState(false);
  const steps = [IssueInputStep, PositionMappingStep, NeedsStep, SolutionsStep];
  const Current = steps[step];

  const saveProgress = async () => {
    if (!map.issue?.trim()) {
      toast.error("Name your issue first, then you can save your progress.");
      return;
    }
    setSaving(true);
    try {
      const payload = {
        title: map.title || map.issue,
        issue: map.issue,
        position_a: map.position_a,
        position_b: map.position_b,
        concerns_a: map.concerns_a,
        needs_a: map.needs_a,
        needs_b: map.needs_b,
        solutions: map.solutions,
        reflection: map.reflection,
        history: map.history || [],
        last_step: step,
      };
      let data;
      if (map.id) ({ data } = await api.put(`/maps/${map.id}`, payload));
      else ({ data } = await api.post("/maps", payload));
      setMap({ ...map, id: data.id });
      toast.success("Progress saved. You can return to this anytime from My Maps.");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    }
    setSaving(false);
  };

  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-8 py-12">
      <div className="flex justify-end mb-4">
        <button
          onClick={saveProgress}
          disabled={saving}
          data-testid="save-progress-button"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm border border-[#4A5D4E]/30 text-[#4A5D4E] hover:bg-[#F5F2EA] transition-all disabled:opacity-60"
        >
          <Save className={`h-4 w-4 ${saving ? "animate-pulse" : ""}`} /> {saving ? "Saving…" : "Save progress"}
        </button>
      </div>
      <Stepper step={step} />
      <Current />
    </div>
  );
}
